<template>
  <div>
    <div id="map" />
    <CreateMarkerDialog v-model="openCreateMarkerDialog" :lat-lng="clickedLatLng"/>
    <MarkerInfoWindow v-if="selectedMarker" :marker="selectedMarker" v-model="openMarkerInfoWindow" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import scriptjs from 'scriptjs'
import {GOOGLE_MAP_KEY} from '@/api_keys'
import {STYLE, CENTER, BOUNDS} from './map_settings'
import CreateMarkerDialog from '@/components/CreateMarkerDialog'
import MarkerInfoWindow from '@/components/MarkerInfoWindow'


export default {
  name: "Map",
  components: {CreateMarkerDialog, MarkerInfoWindow},
  props: {
    center: {
      type: Object,
      default: () => CENTER
    },
    zoom: {
      type: Number,
      default: 13
    },
    bounds: {
      type: Object,
      default: () => BOUNDS
    }
  },
  data() {
    return {
      map: null,
      markerObjects: [],
      openCreateMarkerDialog: false,
      clickedLatLng: null,
      selectedMarker: null,
      openMarkerInfoWindow: false,
    };
  },
  computed: mapState({
    markers: 'markers',
  }),
  watch: {
    markers() {
      this.updateMarkers();
    }
  },
  mounted() {
    scriptjs(
      "https://maps.googleapis.com/maps/api/js?key="+GOOGLE_MAP_KEY,
      "loadGoogleMap"
    );
    scriptjs.ready("loadGoogleMap", this.initMap);
  },
  methods: {
    updateMarkers() {
      for (let marker of this.markerObjects) {
        marker.setMap(null);
      }
      this.markerObjects.splice(0, this.markerObjects.length); // remove all objects
      for (let marker of this.markers) {
        try {
          let icon;
          const ICON_SIZE = marker.createdBy.admin?96:64;
          if (marker.markerImage) {
            icon = {
              url: marker.markerImage,
              //labelOrigin: new google.maps.Point(ICON_SIZE/2, ICON_SIZE/2),
              labelOrigin: new google.maps.Point(ICON_SIZE/2, ICON_SIZE/2),
              scaledSize: new google.maps.Size(ICON_SIZE, ICON_SIZE),
            };
          } else {
            icon = null;
          }
          let label = null;
          if (marker.createdBy) {
            label = {
              text: marker.createdBy.name,
              fontSize: "14px",
              fontFamily: "Roboto",
              fontWeight: "bold",
              //color: "#ffffffdd",
              color: "#ffffffff",
            }
          }
          let markerObject = new google.maps.Marker({
            position: {lat:marker.location.latitude, lng:marker.location.longitude},
            map: this.map,
            icon: icon,
            label: label,
          });

          let that = this;
          markerObject.addListener("click", function() {
            that.map.panTo({lat:marker.location.latitude, lng:marker.location.longitude});
            that.selectedMarker = marker;
            that.openMarkerInfoWindow = true;
          });

          this.markerObjects.push(markerObject);

        } catch (TypeError) {
          console.log(TypeError);
        }
      }
    },

    initMap() {
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: this.center,
        zoom: this.zoom,
        restriction: {
          latLngBounds: this.bounds,
          strictBounds: true,
        },
        styles: STYLE,
        draggableCursor: "auto",
        draggingCursor: "grabbing",
        gestureHandling: "greedy", // Move maps by swipe on mobile device.
        disableDefaultUI: true,
      });

      let that = this;
      this.map.addListener('click', function(event) {
        if (that.$store.state.siteClosed) {
          return;
        }
        // check infowindow is opened or not
        if (that.currentInfoWindow && that.currentInfoWindow.getMap()) {
          that.currentInfoWindow.close()
        } else if(!that.$store.state.isGuest) {
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();
          if (lat < that.bounds.south || lat > that.bounds.north || lng < that.bounds.west || lng > that.bounds.east) {
            return;
          }
          that.clickedLatLng = {lat:lat, lng: lng}
          that.openCreateMarkerDialog = true;
        }
      });
      new google.maps.Polygon({
        map: this.map,
        strokeWeight: 0,
        fillColor: '#000000',
        fillOpacity: 0.6,      
        clickable: false,
        paths: [
          [
            {lat: 50, lng: 120},
            {lat: 0, lng: 120},
            {lat: 0, lng: 150},
            {lat: 50, lng: 150},
            {lat: 50, lng: 120},
          ],[
            {lat: this.bounds.north, lng: this.bounds.west},
            {lat: this.bounds.north, lng: this.bounds.east},
            {lat: this.bounds.south, lng: this.bounds.east},
            {lat: this.bounds.south, lng: this.bounds.west},
            {lat: this.bounds.north, lng: this.bounds.west},
          ]
        ]
      });

      this.updateMarkers();
    }
  }
};
</script>

<style scoped>
#map {
  height: 100%;
  width: 100%;
}
</style>
